import React from 'react';
import { feature } from 'react-openlayers';
import { Coordinate } from 'ol/coordinate';

type EndPointFeatureProps = {
  coords: Coordinate;
  id: string;
  selected?: boolean;
  properties?: [key: string];
  zIndex?: number;
};

const EndPointFeature = ({ coords, id, selected = false, properties, zIndex }: EndPointFeatureProps) => {
  return (
    <feature.PointReact
      coordinate={coords}
      iconOptions={{
        src: './images/end-point.png',
        anchor: [0.5, 0.5],
        scale: selected ? 0.3 : 0.2,
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        opacity: 0.8,
      }}
      properties={properties}
      key={id}
      zIndex={zIndex}
    />
  );
};

export default EndPointFeature;
